<button
  #menuButton
  class="sidePanelMenuButton"
  (click)="action()"
  [class.sidePanelMenuButton--active]="ppActive"
  [class.sidePanelMenuButton--disabled]="ppDisabled"
  [class.sidePanelMenuButton--panelToggle]="ppTogglesPanel"
>
  <div class="sidePanelMenuButton__image">
    <pp-icon
      class="sidePanelMenuButton__icon"
      data-testid="side-panel-menu-button-icon"
      [ppSrc]="ppIconSrc"
      ppClass="setSize24"
      [ppColor]="iconColor"
    ></pp-icon>

    <!-- Red dot for reminders, there was no other way to preserve color -->
    @if (ppShowIndicator) {
      <pp-icon
        class="sidePanelMenuButton__indicator"
        ppClass="setSize24"
        [ppSrc]="EIconPath.SIDE_PANEL_REMINDER_NOTIFICATION"
      ></pp-icon>
    }
  </div>

  <span class="sidePanelMenuButton__text">
    {{ ppText }}
  </span>
</button>
